import { INVOICE_DATA_CURRENT, INVOICE_DATA_FILTER } from '../../mutationTypes'
import _ from 'lodash';

const mutations = {
  [INVOICE_DATA_CURRENT](state, action){
    state.current = action.invoiceData
  },
  [INVOICE_DATA_FILTER](state, action){
    const filter = _.clone(state.filter);
    filter.dateFrom = action.dateFrom;
    filter.dateTo = action.dateTo;
    filter.customerId = action.customerId;
    state.filter = filter
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/invoiceData/invoiceDataMutations.js